// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tag, Tooltip } from "antd";
import { NEWS_PRIORITY } from "../../../../utils/Constant";
import { useTranslation } from "react-i18next";

type NewsPriorityProps = {
  priority: number;
};

const customTooltipDelay = 0.05;

const NewsPriorityTag: React.FunctionComponent<NewsPriorityProps> = (
  props: NewsPriorityProps
) => {
  const { t } = useTranslation();
  const { priority } = props;
  const newsPriority = NEWS_PRIORITY[priority - 1]; // priority is 1-based

  return (
    <Tooltip
      mouseEnterDelay={customTooltipDelay}
      mouseLeaveDelay={customTooltipDelay}
      placement="topLeft"
      title={t(`add_news.priority.tooltips.${newsPriority.label}`)}
      style={{
        width: "50%"
      }}
    >
      <Tag color={newsPriority.color}>
        {t(`add_news.priority.${newsPriority.label}`)}
      </Tag>
    </Tooltip>
  );
};

export default NewsPriorityTag;
